import {IconButton, Stack} from "@mui/material";
import {useMemo, useRef} from "react";
import { useTranslation } from "react-i18next";
import {DescriptionRounded} from "@mui/icons-material";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import {AgGridReact} from "ag-grid-react";
import {Link} from "react-router-dom";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";

const SearchToolTable = ({serverSideDatasource}: any) => {
    const {t, i18n} = useTranslation(['network', 'translation']);

    const gridRef = useRef<AgGridReact>(null);
    const columnDefs = useMemo<ColDef[]>(() =>[
        {
            field: "applicationIdentifyingCode",
            headerName: "",
            width: 70,
            resizable: false,
            suppressMovable: true,
            suppressSizeToFit: false,
            suppressColumnsToolPanel: true,
            pinned: 'right',
            cellRenderer: (params: ICellRendererParams) => {
                const url = `/mobility-store/application-detail/${params.data.id}`;
                return (
                    <Stack direction={"row"} justifyContent={"center"}>
                        <Link to={url} target="_blank">
                            <IconButton color="accent">
                                <DescriptionRounded />
                            </IconButton>
                        </Link>
                    </Stack>
                );
            }
        },
        {
            field: "applicationIdentifyingCode",
            headerName: t("searchApplication.form.label.searchFilters.applicationId"),
            sortable: true
        },
        {
            field: "applicant.name",
            headerName: t("searchApplication.form.label.searchFilters.name"),
            sortable: true
        },
        {
            field: "applicant.surname",
            headerName: t("searchApplication.form.label.searchFilters.surname"),
            sortable: true
        },

        {
            field: "applicant.companyName",
            headerName: t("searchApplication.form.label.searchFilters.companyName"),
            sortable: true
        },
        {
            field: "applicant.city",
            headerName: t("searchApplication.form.label.searchFilters.city"),
            sortable: true
        },
        {
            field: "applicant.address",
            headerName: t("searchApplication.form.label.searchFilters.address"),
            sortable: true
        },
        {
            field: "applicant.region",
            headerName: t("searchApplication.form.label.searchFilters.region"),
            sortable: true
        },
        {
            field: "postalCode",
            headerName: t("searchApplication.form.label.searchFilters.postalCode"),
            sortable: true
        },
        {
            field: "applicant.vatNumber",
            headerName: t("searchApplication.form.label.searchFilters.vatNumber"),
            sortable: true
        },
        {
            field: "currentStatus",
            headerName: t("searchApplication.form.label.searchFilters.currentStatus"),
            sortable: true
        },
        {
            field: "areaOfApplicationStatus",
            headerName: t("searchApplication.form.label.searchFilters.areaOfApplicationStatus"),
            sortable: true
        },
        {
            field: "applicant.newPartner",
            headerName:  t("searchApplication.form.label.searchFilters.newPartner"),
            sortable: true
        }
    ], [i18n.language]);


    return (
        <AgGridCustomTable
            gridRef={gridRef}
            rowModelType={'serverSide'}
            serverSideInfiniteScroll={true}
            serverSideDatasource={serverSideDatasource}
            columnDefs={columnDefs}
            gridOptions={
                {
                    defaultColDef: { lockPinned: true, resizable: true, suppressSizeToFit: true },
                    onGridReady: (event) => {
                        event.api.sizeColumnsToFit()
                    }
                }
            }
        />
    )
}

export default SearchToolTable;
